module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "oak-haven-timber-hamilton-0.ff9eb2bb.jpg";